import React from 'react';
import {
  Modal, ModalContent, ModalHeader, ModalCloseButton, UseDisclosureProps, ModalOverlay, ModalBody,
  ModalFooter, Text, DarkMode, useBreakpointValue, Stack
} from '@chakra-ui/react';

import { IGroup, IQuestionGroup } from '../interfaces/Models';
import { StyledButton } from '../styled-components/StyledButton';

interface IProps extends UseDisclosureProps {
  questionGroup: IQuestionGroup;
  group?: IGroup;
  email?: string;
}

export const OnSubmitEntryModal = (props: IProps) => {
  const { isOpen, onClose, questionGroup, group, email } = props;

  const modalSize = useBreakpointValue(["xs", "md"]);

  const onCreateGroupClick = () => {
    const params = new URLSearchParams();
    if (group) params.set('groupId', group.id);
    if (email) params.set('email', email);
    const qs = params.toString();
    window.open(`${window.location.origin}/create-group/${questionGroup.id}${qs ? `?${qs}` : ''}`, '_blank');
  };

  return (
    <DarkMode>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size={modalSize}
      >
        <ModalOverlay />
        <ModalContent backgroundColor={"background"}>
          <ModalHeader>Your picks are in!</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Stack spacing={[2, 4]}>
              <Text>
                Once the Super Bowl starts, this page will update with live rankings and everyone's picks.
              </Text>
              <Text>
                Have other friends you want to play with? Create your own group for free — your picks will carry over!
              </Text>
            </Stack>
          </ModalBody>
          <ModalFooter>
            <StyledButton
              mr={3}
              colorScheme="brandColorScheme"
              onClick={onCreateGroupClick}
            >
              Create Free Group
            </StyledButton>
            <StyledButton
              colorScheme="brandColorScheme"
              onClick={onClose}
              variant="ghost"
            >
              Close
            </StyledButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </DarkMode>
  );
};
